import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-brand">
            <h3>Trckle</h3>
            <p>The All-In-One Social Hub</p>
          </div>
          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} Trckle. All rights reserved.</p>
          </div>
        </div>
        <div className="footer-right">
          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
            <Link to="/data-deletion" className="footer-link">Data Deletion</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
